import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { useTranslation } from 'react-i18next';

import { PrivateRoute as Route } from './hoc/PrivateRoute/PrivateRoute';
import DownloadCenterLanding from './pages/DownloadCenterLanding/DownloadCenterLanding';
import OverviewReports from './pages/OverviewReports/OverviewReports';
import ViewReport from './pages/ViewReport/ViewReport';
import { useFetchStaticData } from './api/hooks';
import { checkCSClient } from "./api/helper";

const AppRoutes = () => {
    const { t } = useTranslation();
    const isCSClient = checkCSClient(useFetchStaticData());
    const DOCUMENT_TITLE_PREFIX = isCSClient ? t('documentTitles.downloadCenter') : t('documentTitles.mbs');

    return (
        <Switch>
            <Route
                path="/overviewReports"
                prefix={DOCUMENT_TITLE_PREFIX}
                title={isCSClient ? t('documentTitles.overviewReports') : ''}
            >
                <OverviewReports />
            </Route>
            <Route
                path="/viewReport/:uuid"
                prefix={DOCUMENT_TITLE_PREFIX}
                title={isCSClient ? t('documentTitles.viewReport') : ''}
            >
                <ViewReport />
            </Route>
            <Route
                exact
                path="/downloadCenterLanding/:token"
                prefix={DOCUMENT_TITLE_PREFIX}
                title={isCSClient ? t('documentTitles.landing') : ''}
            >
                <DownloadCenterLanding />
            </Route>


            {/* `/` should be left as last route to act as default */}
            <Route path="/">
                <Redirect to="/overviewReports" />
            </Route>
        </Switch>
    )
}

export default AppRoutes;

export const history = createBrowserHistory();